import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosInstanceRow } from "../Config";


// Add provider action
export const addProvider = createAsyncThunk("provider", async (payload) => {
    const apiResponse = await axiosInstance.post(`/providers`, payload);
    return apiResponse.data;
}
);

//  get the list of provider
export const getProvider = createAsyncThunk('get-provider', async (payload) => {
    const apiResponse = await axiosInstance.get(`/providers`, { params: payload, });
    return apiResponse.data;
});


// delete provider
export const deleteProvider = createAsyncThunk('delete-provider', async (id) => {
    const apiResponse = await axiosInstance.delete(`/providers/${id}`);
    return apiResponse.data;
});

//  upadte provider
export const updateProvider = createAsyncThunk("update-provider", async ({ id, payload }) => {
    const apiResponse = await axiosInstance.put(`/providers/${id}`, payload);
    return apiResponse.data;
});

// search provider
export const searchProvider = createAsyncThunk("search-provider", async (payload) => {
    const apiResponse = await axiosInstance.get(`/providers/search`, { params: payload });
    return apiResponse.data;
});


//  Add Type
export const addType = createAsyncThunk('add-type', async (payload) => {
    const apiResponse = await axiosInstance.post(`/types`, payload);
    return apiResponse.data;
});

// get add type

export const getAddType = createAsyncThunk('getaAdd-type', async (payload) => {
    const apiResponse = await axiosInstance.get(`/types`, { params: payload, });
    return apiResponse.data;
});

// delete type
export const deleteType = createAsyncThunk('delete-type', async (id) => {
    const apiResponse = await axiosInstance.delete(`/types/${id}`);
    return apiResponse.data;
});

// update type
export const updateType = createAsyncThunk("update-type", async ({ id, payload }) => {
    const apiResponse = await axiosInstance.put(`/types/${id}`, payload);
    return apiResponse.data;
});

// search type
export const searchType = createAsyncThunk("search-types", async (payload) => {
    const apiResponse = await axiosInstance.get(`/types/search`, { params: payload });
    return apiResponse.data;
});


// Add member 
export const addMember = createAsyncThunk('add-member', async (payload) => {
    const apiResponse = await axiosInstanceRow.post(`/members`, payload);
    return apiResponse.data;
});

// getting memebr list

export const getMemberList = createAsyncThunk('get-member-list', async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/members`, { params: payload });
    return apiResponse.data;
});

// delete member detail
export const deleteMemberDetail = createAsyncThunk('delete-member-detail', async (id) => {
    const apiResponse = await axiosInstance.delete(`/members/${id}`);
    return apiResponse.data;
});

// getting detail of individual member

export const gettingDetail = createAsyncThunk('individual-member-detail', async (id) => {
    const apiResponse = await axiosInstance.get(`/members/${id}`);
    return apiResponse.data;
});


//update member

export const updateMember = createAsyncThunk("update-member", async ({ id, payload }) => {
    const apiResponse = await axiosInstance.put(`/members/${id}`, payload);
    return apiResponse.data;
});

// search member
export const memberTypeData = createAsyncThunk("search-members", async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/members/search`, { params: payload });
    return apiResponse.data;
});


// get All clients

export const getAllClients = createAsyncThunk("clients", async (payload) => {
    const apiResponse = await axiosInstance.get(`/clients`, payload)
    return apiResponse.data;
})

// add clients

export const addClient = createAsyncThunk("add-clients", async (payload) => {
    const apiResponse = await axiosInstance.post(`/clients`, payload)
    return apiResponse.data;
})

// update client

export const updateClient = createAsyncThunk("update-clients", async ({ id, payload }) => {
    const apiResponse = await axiosInstance.put(`/clients/${id}`, payload)
    return apiResponse.data;
})

// delete client

export const deleteClient = createAsyncThunk("delete-clients", async (id) => {
    const apiResponse = await axiosInstance.delete(`/clients/${id}`)
    return apiResponse.data;
})

// search client
export const searchClientData = createAsyncThunk("search-client", async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/clients/search`, { params: payload });
    return apiResponse.data;
});

// add cheque
export const addCheque = createAsyncThunk("add-cheque", async (payload) => {
    const apiResponse = await axiosInstance.post(`/manual-cheque`, payload);
    return apiResponse.data;
});

// get cheque list
export const getChequeList = createAsyncThunk("list-cheque", async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/manual-cheque`, payload);
    return apiResponse.data;
});

// update cheque detail by id

export const getChequeDetailByID = createAsyncThunk("update-cheque-by-id", async ({ id, payload }) => {
    const apiResponse = await axiosInstance.post(`/manual-cheque/${id}`, payload);
    return apiResponse.data;
});
// delte cheque detail
export const deleteChequeById = createAsyncThunk("delete-cheque", async (id) => {
    const apiResponse = await axiosInstanceRow.delete(`/manual-cheque/${id}`);
    return apiResponse.data;
});


// add cheque type
export const addChequeType = createAsyncThunk("cheque-type", async (payload) => {
    const apiResponse = await axiosInstance.post(`/cheque-type`, payload);
    return apiResponse.data;
});

// list of cheque type
export const getChequeType = createAsyncThunk("cheque-typeList", async (payload) => {
    const apiResponse = await axiosInstance.get(`/cheque-type`, payload);
    return apiResponse.data;
});

// update checque type 
export const updateChequeType = createAsyncThunk("cheque-typeList-update", async ({ id, payload }) => {
    const apiResponse = await axiosInstance.post(`/cheque-type/${id}`, payload);
    return apiResponse.data;
});

// delete cheque type

export const deleteChequeType = createAsyncThunk("delete-cheque-type", async (id) => {
    const apiResponse = await axiosInstanceRow.delete(`/cheque-type/${id}`);
    return apiResponse.data;
});


// update cheque details after manage from cheque list after read by ai
export const updateChequeDetails = createAsyncThunk("cheque-detail-AI", async (payload) => {
    const apiResponse = await axiosInstanceRow.post(`/save-processing-cheque`, payload);
    return apiResponse.data
})

// add cheque details manually if not upload and not read by ai
export const SubmitManuallChequeDetails = createAsyncThunk("cheque-detail-manually", async (payload) => {
    const apiResponse = await axiosInstanceRow.post(`cheque-details/bulk-update`, payload);
    return apiResponse.data
})

// billing detail of new member
export const manuallyChequeDetail = createAsyncThunk("cheque-manually-after-process", async (id) => {
    const apiResponse = await axiosInstanceRow.get(`/cheque-details/${id}`);
    return apiResponse.data
})

//  add new cheque detail from manual cheque entry form

// billing detail of new member
export const addNewChequeDetails = createAsyncThunk("cheque-new-detail", async (payload) => {
    const apiResponse = await axiosInstanceRow.post(`/manually-processing-cheque`, payload);
    return apiResponse.data
})


// api for dahboard cards count
export const cardsCount = createAsyncThunk("dashboard-cards", async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/dashboard`, payload);
    return apiResponse.data
})

// for chart on dashboard
export const chartData = createAsyncThunk("dashboard-chart", async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/dashboard/revenue-overview`, { params: payload });
    return apiResponse.data
})


// for dashboard quick stats yearly base
export const quickStats = createAsyncThunk("dashboard-stats", async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/dashboard/revenue-overview`, { params: payload });
    return apiResponse.data
})


// for dahboard client tabel view

export const clientOverview = createAsyncThunk("dashboard-client", async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/client-billing-list`, { params: payload });
    return apiResponse.data
})

// client overview analytics on dahbaord 
export const clientChartData = createAsyncThunk("dashboard-chart-client", async ( payload ) => {
    const apiResponse = await axiosInstanceRow.get(`/client-billing-graph`, { params: payload });
    return apiResponse.data
})